angular.module('app').run(['amMoment', function(amMoment) {
  amMoment.changeLocale(I18n.locale.replace('-CH', ''));
  moment.lang(I18n.locale.replace('-CH', ''));
}]);